// extracted by mini-css-extract-plugin
export default {"packagesContainer":"SelectPackage_packagesContainer__dPYqK"};